import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import poolData from './config';
// import { deleteToken, messaging } from '@/config/firebaseNotification';
// import { requestFCMToken } from '@/config/firebaseNotification';
// import axios from '../../node_modules/axios/index';
const userPool = new CognitoUserPool(poolData);

export function CognitoAuthentication() {
  const signIn = async (Username, Password) => {
    return new Promise((resolve, reject) => {
      const cognitoUser = new CognitoUser({
        Username: Username,
        Pool: userPool,
      });
      let authenticationData = {
        Username: Username,
        Password: Password,
      };

      let authenticationDetails = new AuthenticationDetails(authenticationData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: async (result) => {
          const idToken = result.getIdToken().getJwtToken();
          localStorage.setItem('token', idToken);
          //extract nickname and store in local storage
          //extractNicknameAndStore(idToken);

          // Push FCM token on login
          // try {
          //   const fcmToken = await requestFCMToken(); // Fetch the FCM token
          //   await axios.patch(
          //     `${import.meta.env.VITE_REACT_APP_BASE_URL}/doctorsappuser/push-fcm-token`,
          //     { fcmToken },
          //     { headers: { Authorization: idToken } }
          //   );
          //   console.log('FCM token pushed');
          // } catch (err) {
          //   console.error('Error pushing FCM token:', err);
          // }

          resolve(idToken);
        },
        onFailure: (err) => {
          console.log(err);
          reject(err.message || JSON.stringify(err));
        },
        newPasswordRequired: () => {
          reject('Please change your password');
        },
      });
    });
  };

  const forceResetPass = async (Username, OldPassword, Newpass) => {
    return new Promise((resolve, reject) => {
      let userData = {
        Username: Username,
        Pool: userPool,
      };
      let cognitoUser = new CognitoUser(userData);
      let authenticationData = {
        Username: Username,
        Password: OldPassword,
      };
      let authenticationDetails = new AuthenticationDetails(authenticationData);
      //Const attributes with my own test userpool
      const attributes = {
        gender: 'male',
        phone_number: '+201118155472',
        name: 'Ahmed',
      };
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {},
        onFailure: (err) => {
          reject(new Error(`Authentication failed: ${err.message || err}`));
        },
        newPasswordRequired: function (res) {
          cognitoUser.completeNewPasswordChallenge(Newpass, attributes, {
            onSuccess: function (res) {
              resolve(res);
            },
            onFailure: function (err) {
              reject(new Error(`Password change failed: ${err.message || err}`));
            },
          });
        },
      });
    });
  };

  const logout = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const user = userPool.getCurrentUser();
        if (user) {
          user.signOut();

          // const token = localStorage.getItem('token');
          // let fcmToken;
          // try {
          //   fcmToken = await requestFCMToken(); // Get current token before deleting
          //   await axios.patch(
          //     `${import.meta.env.VITE_REACT_APP_BASE_URL}/doctorsappuser/pull-fcm-token`,
          //     { fcmToken },
          //     { headers: { Authorization: token } }
          //   );
          //   console.log('FCM token pulled');

          //   await deleteToken(messaging);
          //   console.log('FCM token deleted on logout');
          // } catch (err) {
          //   console.error('Error pulling or deleting FCM token:', err);
          // }

          const lang = localStorage.getItem('language');
          localStorage.clear();
          localStorage.setItem('language', lang);

          // Notify service worker of signout
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.controller?.postMessage({
              type: 'AUTH_STATE',
              isAuthenticated: false,
            });
          }

          resolve(user);
        } else {
          reject('Please login first');
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  const changePassword = async (oldPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      if (!user) {
        return reject(new Error('No user is currently logged in.'));
      }

      user.getSession((err, session) => {
        if (err || !session.isValid()) {
          return reject(new Error('Session is invalid or expired. Please login again.'));
        }

        user.changePassword(oldPassword, newPassword, (err, result) => {
          if (err) {
            console.error('Password change error:', err.code);
            return reject(new Error(err.message || 'Failed to change password'));
          } else {
            resolve(result);
          }
        });
      });
    });
  };

  return { signIn, forceResetPass, logout, changePassword };
}
